import React, { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import _get from 'lodash.get'
import { replaceWSTabLB, smsHTMLToText } from '@nixi1/nx-channel-utils'

import { apiMnemonics, apiUsers } from 'api'
import { isDisabledComposerForChatweb, isDisabledForChatmail, isDisabledSend, isMessageEmpty } from './utils/validations'
import conversations from 'api/conversation/conversations'
import { SocketWall } from 'socket'
import { composerAct } from '../../../../redux/actions'
import { openOutbound } from '../../../../redux/outbound/actions'
import composerActions from '../../../../redux/actions/conversations/composerAct'
import { toastMessage } from 'utils/messages'
import { isConversationOnline } from 'utils/helpers'
import { seenTicket } from 'redux/mnemonics/actions'
import ChatComposerUI from './ChatComposerUI'

const _ = require('lodash')
const CHANNEL_CONTACT_INFO = ['facebook', 'chatweb', 'instagram']
const CHANNEL_CHECK_PHONE = ['facebook', 'instagram']
const ABBR_DOT = '<p>.'
const ABBR_DOT_SIZE = ABBR_DOT.length

const ChatComposer = (props) => {
  const {
    userId,
    composer,
    composer: { messageType = 'text', files = [], buttons = [], uploading = false, message = '', sending = false },
    conversationUser,
    getSubjects,
    loadingSubjects,
    subjects,
    setSubjects,
    subjectsIsOpen,
    setSubjectsIsOpen,
    chatmailHeader,
    setChatmailHeader,
    subjectsFilterOptions,
    filterValues,
    setFilterValues,
    setIsSubjectFiltered,
    toggleContactLockedModal,
    statesOptions,
    isVirtualAssistantActive,
    dispatch,
    handleDeleteSubject
  } = props
  const history = useHistory()
  const composerAction = bindActionCreators(composerAct, dispatch)
  const openOutboundAction = bindActionCreators(openOutbound, dispatch)

  const [currentCampaing, setCurrentCampaing] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [showSendMessageModal, setShowSendMessageModal] = useState(false)
  const [showEmojis, setShowEmojis] = useState(false)
  const [showCamera, setShowCamera] = useState(false)
  const [showVideo, setShowVideo] = useState(false)
  const [showAIResponses, setShowAIResponses] = useState(composer.suggestions?.length > 0)
  const [showShortcutMenu, setShowShortcutMenu] = useState(false)
  const [shortcuts, setShortcuts] = useState(props.shortcuts)
  const [shortcutCharPosition, setShortcutCharPosition] = useState(-1)
  const [modalMaxButtonsOpen, setModalMaxButtonsOpen] = useState(false)
  const [shortcutButtons, setShortcutButtons] = useState([])
  const [showModalButtons, setShowModalButtons] = useState(false)
  const [showAudioRecorder, setShowAudioRecorder] = useState(false)
  const [isOpenModalSendSMS, setIsOpenModalSendSMS] = useState(false)
  const [numbersSMS, setNumbersSMS] = useState([])
  const [numberSelected, setNumberSelected] = useState(null)
  const [numberToSendSMS, setNumberToSendSMS] = useState('')
  const [sendingSMS, setSendingSMS] = useState(false)
  const [errorModalSendSMS, setErrorModalSendSMS] = useState('')
  const [dialCode, setDialCode] = useState('')
  const [numberToSendSMSMessage, setNumberToSendSMSMessage] = useState('')
  const [dropZoneIsVisible, setDropZoneIsVisible] = useState(false)
  const [filesErrorMessage, setFilesErrorMessage] = useState('')
  const [headerInput, setHeaderInput] = useState({ type: '', value: '' })
  const [users, setUsers] = useState({})
  const [chatmailHeaderError, setChatmailHeaderError] = useState(false)
  const [refEditor, setRefEditor] = useState(null)
  const [isOnline, setIsOnline] = useState(true)
  const [useTemplate, setUseTemplate] = useState(false)
  const [chatmailCheckedSubjects, setChatmailCheckedSubjects] = useState({})
  const [chatmailAllCheckedSubjects, setChatmailAllCheckedSubjects] = useState('none')

  const channel = _get(conversationUser, 'channels.0.channel', conversationUser.provider_name)
  const provider = _get(conversationUser, 'channels.0.provider', conversationUser.provider_name)
  const isChatmail = provider === 'chatmail'
  const isWall = provider === 'wall'
  const isSms = provider === 'twilio' && channel === 'sms'
  const isFacebookPost = channel === 'facebook_post'
  const isInstagramPost = channel === 'instagram_post'
  const { channelToken } = conversationUser
  const acceptTypes = isFacebookPost ? 'image/*,video/*' : ''
  const disclaimerMessage = isSms && composer.files?.length ? (
    <p dangerouslySetInnerHTML={{ __html: I18n.t('templates_copy_disclaimer_sms1') }}></p>
  ) : null
  const [vaSuggestion, setVaSuggestion] = useState({
    logId: '',
    withChanges: false,
    confidence: 0,
    id: ''
  })
  const chatmailInputButtons = {
    cc: {
      title: 'Cc',
      onClick: () => setChatmailHeader(prevState => ({
        ...prevState,
        visibleFields: [...prevState.visibleFields, 'cc']
      })),
    },
    cco: {
      title: 'Cco',
      onClick: () => setChatmailHeader(prevState => ({
        ...prevState,
        visibleFields: [...prevState.visibleFields, 'cco']
      }))
    }
  }

  const disableComposer = (isOnline, channel) => {
    if (channel === 'chatweb' && !isOnline && !composer.isWallEnabledForSMS) {
      return true
    } else {
      return false
    }
  }

  const disabledSend = isDisabledSend({
    message, buttons, messageType,
    isLoading: uploading || sending,
    attachments: files,
    conversationState: conversationUser.state,
    isDisabledChatmail: isDisabledForChatmail({
      provider, messageType,
      subjectId: composer.currentSubject?._id,
      to: chatmailHeader.to
    }),
    isDisabledChatweb: isDisabledComposerForChatweb({
      channel,
      isOnline: conversationUser.isOnline,
      isWallEnabledForSMS: composer.isWallEnabledForSMS
    }),
  })

  const withTag = ['whatsapp', 'facebook', 'instagram'].includes(channel)
  let lastMessage = new Date(conversationUser.lastMessageDate)
  lastMessage = lastMessage.setHours(lastMessage.getHours() + 24)
  const show = props.composer.isDeferred || new Date() > lastMessage

  useEffect(() => {
    updateEditor(props.composer.message)
    setChatmailHeader({ visibleFields: ['to'] })
    setHeaderInput({ type: '', value: '' })
    dispatch(seenTicket({ ticketId: conversationUser.id }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationUser.id])

  useEffect(() => {
    setIsOnline(isConversationOnline(conversationUser))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationUser])

  useEffect(() => {
    let error = false
    const toValues = []
    chatmailHeader.to && chatmailHeader.to.chips.forEach(chip => {
      if (chip.isValid === false) error = true
      if (chip.name || chip.email) {
        toValues.push({ id: chip.id })
      } else {
        toValues.push({ identifier: chip.value })
      }
    })

    const ccValues = []
    chatmailHeader.cc && chatmailHeader.cc.chips.forEach(chip => {
      if (chip.isValid === false) error = true
      if (chip.name || chip.email) {
        ccValues.push({ id: chip.id })
      } else {
        ccValues.push({ identifier: chip.value })
      }
    })

    const ccoValues = []
    chatmailHeader.cco && chatmailHeader.cco.chips.forEach(chip => {
      if (chip.isValid === false) error = true
      if (chip.name || chip.email) {
        ccoValues.push({ id: chip.id })
      } else {
        ccoValues.push({ identifier: chip.value })
      }
    })
    setChatmailHeaderError(error)
    dispatch(composerActions.setChatmailHeader({
      to: toValues,
      cc: ccValues,
      cco: ccoValues
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatmailHeader, composer.currentSubject])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (headerInput.value.length > 2) {
        conversations.getUsersOPTOUT({
          channel: props.conversationUser.provider_name,
          text: headerInput.value
        })
          .then(({ data }) => setUsers({ [headerInput.type]: data }))
      } else {
        setUsers([])
      }
    }

    return () => isSubscribed = false
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerInput])

  useEffect(() => {
    let tagCamp = ''

    if (props.conversationUser.campaigns) {
      const ls = props.conversationUser.campaigns.filter((el) => {
        const dt1 = new Date(el.endDate)
        const dt2 = new Date()

        return dt1 > dt2
      })
      const last = ls.pop()
      tagCamp = last ? last.toDisplay : ''
    }
    setCurrentCampaing(tagCamp)
  }, [props.conversationUser.campaigns])

  useEffect(() => {
    if (composer.suggestions?.length > 0) {
      setShowAIResponses(true)
    }
  }, [composer.suggestions])

  useEffect(() => {
    if (props.composer.message.length <= 0) {
      updateEditor()
      resetVaSuggestion()
      setFilesErrorMessage('')
      if (isWall) {
        SocketWall.emitWritting({
          userId: conversationUser._id,
          isWritting: false
        })
      }
    } else {
      if (isWall) {
        SocketWall.emitWritting({
          userId: conversationUser._id,
          isWritting: true
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.composer.message])

  useEffect(() => {
    if (props.composer.addExternalText !== '') {
      updateEditor(props.composer.addExternalText)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.composer.addExternalText])

  useEffect(() => {
    if (isOpenModalSendSMS) {
      setShowSendMessageModal(false)
    }
    else {
      setNumberSelected(null)
      setSendingSMS(false)
      setTimeout(() => {
        setDialCode('')
        setNumberToSendSMS('')
        setNumbersSMS([])
        setNumberToSendSMSMessage('')
      }, 1000)
    }
  }, [isOpenModalSendSMS])

  useEffect(() => {
    setErrorModalSendSMS('')
  }, [numberSelected, numberToSendSMS])

  useEffect(() => {
    if (!subjects.length) return

    if (
      subjects.every(subject => Object.keys(chatmailCheckedSubjects).includes(subject._id))
      && Object.keys(chatmailCheckedSubjects).every(subjectId => chatmailCheckedSubjects[subjectId])
    ) {
      setChatmailAllCheckedSubjects('checked')
    } else if (
      Object.keys(chatmailCheckedSubjects).some(subjectId => chatmailCheckedSubjects[subjectId])
    ) {
      setChatmailAllCheckedSubjects('some')
    }
    else {
      setChatmailAllCheckedSubjects('none')
    }
  }, [subjects, chatmailCheckedSubjects])

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    setShortcuts(props.shortcuts)
  }, [props.shortcuts])

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    let charPosition = -1
    const message = props.composer.message

    if (message.slice(0, ABBR_DOT_SIZE) === ABBR_DOT) {
      charPosition = ABBR_DOT_SIZE
    }

    const lastIndex = message.lastIndexOf('./')
    if (lastIndex !== -1) {
      charPosition = lastIndex + 2
    }

    setShortcutCharPosition(charPosition)
    if (charPosition !== -1) {
      setShowShortcutMenu(true)
      const filterMessage = message.substring(charPosition).replace(/<p>|<\/p>/gm, '')
      const [text, ...aBrs] = filterMessage.split('<br>')

      if (filterMessage) {
        const filteredCategories = props.shortcuts.filter(shortcut =>
          shortcut.category.toLowerCase().startsWith(text.toLowerCase())
        )
        const filteredShortcuts = props.shortcuts.filter(shortcut =>
          shortcut.keyboardShortcut.toLowerCase().startsWith(text.toLowerCase())
        )
        if (filteredShortcuts?.length > 0) {
          if (filteredCategories.length > 0) {
            //MERGE CATEGORIAS CON SHORTCUTS
            const merged = _.merge(_.keyBy(filteredCategories, 'keyboardShortcut'), _.keyBy(filteredShortcuts, 'keyboardShortcut'))
            setShortcuts(_.values(merged))
          }
          else {
            setShortcuts(filteredShortcuts)
          }
        }
        else {
          setShortcuts(filteredCategories)
        }
        if (aBrs.length) {
          shortcuts.length === 1 && selectShortcut(0)
        }
      } else {
        setShortcuts(props.shortcuts)
      }
    } else {
      setShowShortcutMenu(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.composer.message])

  const updateEditor = useCallback(
    (value = '') => {
      if (refEditor?.__componentStatus === 'ready') {
        const isEmpty = isMessageEmpty(refEditor?.getEditorValue()) // Fix editor lost focus
        if (!value && isEmpty) return

        refEditor.setEditorValue(value)
      }
    }, [refEditor]
  )

  const onToggleButtons = () => setShowModalButtons(!showModalButtons)

  const onWriteMessage = ({ target }) => {
    composerAction.updateMessage(target.value === '<p><br></p>'
      ? ''
      : target.value
    )
  }

  const onSelectEmoji = (emoji) => {
    refEditor && refEditor.selection.insertHTML(emoji.native)
    onToggleEmojis()
  }

  const sendPhoto = (cameraPhotoUrl) => {
    composerAction.uploadFiles([{ file: cameraPhotoUrl }])
    setShowCamera(false)
  }
  const sendVideo = (cameraVideoUrl) => {
    return new Promise((resolve, reject) => {
      composerAction.uploadFiles([{ file: cameraVideoUrl }]).then(() => {
        setShowVideo(false)
        resolve()
      })
    })
  }

  const onToggleModal = () => setShowModal(!showModal)
  const onToggleEmojis = (values) => setShowEmojis(values?.requireToClose ? false : !showEmojis)

  const onToggleNote = () => {
    if (composer.isWallEnabledForSMS) dispatch(composerAct.setWallEnabledForSMS({ isWallEnabledForSMS: false }))
    composer.messageType !== 'note'
      ? composerAction.changeMessageType('note')
      : composerAction.changeMessageType('text')
  }

  const toggleOpenSendMessage = () => {
    const isOpen = !isOpenModalSendSMS
    if (isOpen) {
      loadDataForSMS()
      getContactInfo()
    }
    setIsOpenModalSendSMS(!isOpenModalSendSMS)
  }

  const resetVaSuggestion = () => {
    setVaSuggestion({
      logId: '',
      withChanges: false,
      confidence: 0,
      id: ''
    })
  }

  const onSendMessage = async () => {
    if (isChatmail && chatmailHeaderError) {
      toastMessage(I18n.t('conversations_message_error_chatmail'), 'error')
      return false
    }
    const {
      message,
      files = [],
      messageType,
      tag,
      buttons,
      selectedTemplate,
      isSurvey,
      chatmailHeader,
      messageId,
      draftToEdit,
      variables
    } = props.composer
    const persistFields = ['currentSubject']

    if (!message && !files.length && !buttons.length) return

    if (composer.suggestions.length && !vaSuggestion.logId){
      persistFields.push('suggestions')
    }

    if (showEmojis) onToggleEmojis()

    vaSuggestion.withChanges = message !== vaSuggestion.content
    delete vaSuggestion.content

    let messageData = {
      message,
      attachments: files,
      checkTime: selectedTemplate ? false : !showSendMessageModal,
      tag,
      buttons,
      vaSuggestion,
      isSurvey,
    }

    if (draftToEdit) messageData.draftId = draftToEdit
    if (variables?.length) {
      messageData.variables = variables.map(it => ({
        ...it, value: replaceWSTabLB(it.value)
      }))
    }

    if (isChatmail) {
      messageData = {
        ...messageData,
        inReplyTo: messageId,
        to: chatmailHeader.to,
        cc: chatmailHeader.cc,
        cco: chatmailHeader.cco,
        subject: composer.currentSubject?.name,
        subjectId: composer.currentSubject?._id
      }
    }

    try {
      await composerAction.sendMessage(messageData, messageType, persistFields)
      updateEditor()
      resetVaSuggestion()
      if (useTemplate) setUseTemplate(false)
      if (showSendMessageModal) setShowSendMessageModal(false)
    } catch (error) {
      if (error.message.includes('Only one attachment')) {
        toastMessage(I18n.t('dashboard_failed-send-message_only-1-attachment'), 'error')
      }
      console.error(error)
    }
  }

  const resetComposer = ({ persistFields }) => {
    if (isWall) {
      composerAction.resetComposer({ persistFields })
    } else {
      composerAction.resetComposer({ persistFields, userId })
    }

    updateEditor()
    setHeaderInput({ type: '', value: '' })
  }

  const onKeyUp = (e) => {
    if (e.shiftKey && e.key === 'Enter') {
      !disabledSend && sendMessageHotKey(e)
    }
  }

  const selectShortcut = (index = 0, e = null) => {
    e && e.preventDefault()
    const selectedShortcut = shortcuts[index]

    if (selectedShortcut) {
      let newMessage = ''
      if (shortcutCharPosition === ABBR_DOT_SIZE) {
        newMessage = selectedShortcut.answerHtml || selectedShortcut.answer || ''
      } else {
        const msg = props.composer.message
        const indexOf = msg.lastIndexOf('./')
        const textOf = msg.substr(indexOf).indexOf('<')
        newMessage += msg.substring(0, indexOf)
        newMessage += msg.substring(indexOf + textOf)

        newMessage += selectedShortcut.answerHtml || selectedShortcut.answer || ''
      }

      updateEditor(newMessage)
      composerAction.updateMessage(newMessage)
      if (selectedShortcut.attachments && selectedShortcut.attachments.length > 0) {
        composerAction.setFiles(files.concat(selectedShortcut.attachments))
      }
      if (selectedShortcut.buttons) {
        if (props.composer.buttons.length + selectedShortcut.buttons.length <= 3) {
          composerAction.updateButtons(props.composer.buttons.concat(selectedShortcut.buttons))
        } else {
          setShortcutButtons(selectedShortcut.buttons)
          setModalMaxButtonsOpen(true)
        }
      }
      setShortcutCharPosition(-1)
    }
  }

  const sendMessageHotKey = (e) => {
    e.preventDefault()
    onSendMessage()
  }

  const buildShortcutMenu = () => {
    if (shortcuts.length > 0) {
      let category = null
      const objects = shortcuts.map((shortcut, index) => {
        let showCategory = category !== shortcut.category ? shortcut.category : null
        category = shortcut.category
        return (
          <div className='shortcuts__category' key={index}>
            {showCategory && <div className='shortcuts__category-title'>{showCategory === 'none'
              ? I18n.t('dashboard_general')
              : showCategory
            }</div>}
            <div className='shortcuts__item' onClick={() => selectShortcut(index)}>
              <div className='shortcuts__key'>{shortcut.keyboardShortcut}</div>
              {typeof shortcut.answer === 'string'
                ? <div className='shortcuts__answer' dangerouslySetInnerHTML={{ __html: smsHTMLToText.replace(shortcut.answer || '') }} />
                : null
              }
            </div>
          </div>
        )
      })
      return objects
    } else {
      return null
    }
  }

  const get24HourModalTitle = () => {
    const isDeferred = props.composer.isDeferred
    if (isDeferred) {
      return 'modal_24hours-notification-title_deferred'
    } else {
      return 'modal_24hours-notification-title'
    }
  }

  const get24HourModalBody = () => {
    const isDeferred = props.composer.isDeferred
    const channel = conversationUser.channels[0].channel
    if (isDeferred) {
      switch (channel) {
        case 'whatsapp':
          return 'modal_24hours-notification_whatsapp'
        case 'facebook':
          return 'modal_24hours-notification_facebook'
        case 'instagram':
          return 'modal_24hours-notification_facebook'
        default:
          return ''
      }
    } else {
      return 'modal_24hours-notification'
    }
  }

  const replaceButtons = () => {
    composerAction.updateButtons(shortcutButtons)
    setShortcutButtons([])
    setModalMaxButtonsOpen(false)
  }

  const uploadAudio = async (value) => {
    const file = new File([value.blob], "capture.wav", { type: 'audio/wav' })
    await composerAction.uploadFiles([{ file: file }])
    setShowAudioRecorder(false)
  }

  const sendSMSMessage = async () => {
    try {

      if (!numberSelected) {
        setErrorModalSendSMS(I18n.t('conversations_message_require_channel'))
        return
      }
      if (CHANNEL_CHECK_PHONE.includes(channel) && (!numberToSendSMS || dialCode === numberToSendSMS || numberToSendSMS === '+')) {
        setErrorModalSendSMS(I18n.t('conversations_message_require_phone'))
        return
      }

      setSendingSMS(true)
      const { message, files = [], buttons } = props.composer
      const messageSMS = {
        content: message,
        contentHtml: message,
        attachments: files,
        buttons: buttons,
        removeEmojisAndAccents: false
      }

      const result = await conversations.sendSMS({
        channelId: numberSelected.value,
        userId: conversationUser.id,
        phone: numberToSendSMS || '',
        message: messageSMS,
        assignToMe: numberSelected.assignToMe
      })
      setSendingSMS(false)
      setIsOpenModalSendSMS(false)
      setDialCode('')
      setNumberToSendSMS('')
      setNumberSelected(null)
      setNumberToSendSMSMessage('')
      if (result.data.userId) {
        resetComposer({})
        updateEditor()
        toastMessage(I18n.t('conversations_message_sent'))
        setTimeout(() => {
          history.push(`${history.location.pathname}?user_id=${result.data.userId}`)
        }, 2000)
      }
    } catch (error) {
      setSendingSMS(false)
      toastMessage(I18n.t('conversations_message_error_sms'), 'error')
    }
  }

  const gotoChannel = () => history.push(`/dashboard/configurations/channels?c=sms`)

  const loadDataForSMS = () => {
    (async () => {
      try {
        const result = await conversations.getChannelsOPTOUT({ type: 'sms' })
        const numbers = []
        result.data.forEach(it => {
          numbers.push({ label: `${it.value} (${it.name || it.delegationName})`, value: it.id, assignToMe: it.assignToMe })
        })
        setNumbersSMS(numbers)
      } catch (error) {
        console.error(error)
      }
    })()
  }

  const getUserPhone = () => {
    if (conversationUser.phone) {
      setNumberToSendSMS(`+${conversationUser.phone}`)
      setNumberToSendSMSMessage(I18n.t('conversations_sms_number_message'))
    }
  }

  const getContactInfo = async () => {
    if (CHANNEL_CONTACT_INFO.includes(channel)) {
      try {
        const { data } = await apiUsers.address.get(conversationUser.id)
        if (!data) return getUserPhone()

        const dialCode = data.results.dialCode.substr(0, 1) === '+'
          ? data.results.dialCode
          : `+${data.results.dialCode}`
        if (dialCode && data.results.telephone) {
          setDialCode(dialCode)
          setNumberToSendSMS(`${dialCode}${data.results.telephone}`)
          setNumberToSendSMSMessage(I18n.t('conversations_sms_number_message'))
        } else {
          getUserPhone()
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  const handleContacts = ({ type, values }) => {
    setChatmailHeader(prevState => ({
      ...prevState,
      [type]: values
    }))
  }

  const handleCloseChatmailField = ({ field }) => {
    const chatmailFieldIndex = chatmailHeader.visibleFields.findIndex(chatmailfield => chatmailfield === field)
    const newChatmailVisibleField = chatmailHeader.visibleFields
    newChatmailVisibleField.splice(chatmailFieldIndex, 1)

    setChatmailHeader(prevState => ({
      ...prevState,
      visibleFields: newChatmailVisibleField,
      [field]: undefined
    }))
  }

  const handleSelectSubject = ({ subject }) => {
    if (composer.currentSubject?._id !== subject._id) {
      // Guarda en Redux el asunto seleccionado
      dispatch(composerActions.setCurrentSubject(subject))
      setIsSubjectFiltered(true)
    }
    setFilterValues(prevState => ({ ...prevState, text: '' }))
    setSubjectsIsOpen(false)

    // Establece el asunto como leído
    if (!subject.read || subject.pendingMsgCount) {
      handleReadSubject({
        cleanPendingMsgCount: true,
        _userId: conversationUser._id,
        userId: conversationUser.id,
        subjectId: subject._id,
        value: true
      })
    }
  }

  const handleStateSubject = ({ userId, subjectId, value }) => {
    const updatedFilteredSubjects = [...subjects]
    const subjectIndex = updatedFilteredSubjects.findIndex(subject => subject._id === subjectId)

    const prevValue = updatedFilteredSubjects[subjectIndex].state
    updatedFilteredSubjects[subjectIndex].state = value
    setSubjects(updatedFilteredSubjects)

    conversations.changeState({
      userId,
      subjectId,
      state: value
    })
      .catch(() => {
        updatedFilteredSubjects[subjectIndex].state = prevValue
        setSubjects(updatedFilteredSubjects)
      })
  }

  const handleReadSubject = ({ _userId, userId, subjectId, value, cleanPendingMsgCount }) => {
    const updatedFilteredSubjects = [...subjects]
    const subjectIndex = updatedFilteredSubjects.findIndex(subject => subject._id === subjectId)

    const prevReadValue = updatedFilteredSubjects[subjectIndex].read
    const prevPendingMsgCountValue = updatedFilteredSubjects[subjectIndex].pendingMsgCount
    updatedFilteredSubjects[subjectIndex].read = value
    if (cleanPendingMsgCount) updatedFilteredSubjects[subjectIndex].pendingMsgCount = 0
    setSubjects(updatedFilteredSubjects)

    conversations.msgRead({
      ticketId: _userId,
      subjectId,
      isRead: value
    })
      .catch(() => {
        updatedFilteredSubjects[subjectIndex].read = prevReadValue
        setSubjects(updatedFilteredSubjects)
      })

    if (cleanPendingMsgCount) {
      apiMnemonics.seen({
        ticketId: userId,
        subjectId,
      })
        .catch(() => {
          updatedFilteredSubjects[subjectIndex].pendingMsgCount = prevPendingMsgCountValue
          setSubjects(updatedFilteredSubjects)
        })
    }
  }

  const handleDragEnter = () => setDropZoneIsVisible(true)
  const handleDragLeave = () => setDropZoneIsVisible(false)

  const onToggleReset = () => {
    const persistFields = ['currentSubject']

    if (composer.suggestions?.length)
      persistFields.push('suggestions')

    resetComposer({ persistFields })

    if (useTemplate) setUseTemplate(false)
  }

  const onPasteAttachments = (files) => {
    dispatch(composerAct.updateFiles(conversationUser.id, files))
  }

  const handleAllCheckedSubjects = (value) => {
    const checkedValue = value === 'checked' ? true : false

    subjects.forEach(subject => {
      setChatmailCheckedSubjects(prevState => ({ ...prevState, [subject._id]: checkedValue }))
    })
    setChatmailAllCheckedSubjects(checkedValue)
  }

  const handleChangeMultipleSubjects = ({ type, value }) => {
    const updatedFilteredSubjects = [...subjects]

    Object.keys(chatmailCheckedSubjects).forEach(subjectId => {
      if (!chatmailCheckedSubjects[subjectId]) return

      const subjectIndex = updatedFilteredSubjects.findIndex(subject => subject._id === subjectId)

      if (type === 'state') {
        const prevValue = updatedFilteredSubjects[subjectIndex].state
        updatedFilteredSubjects[subjectIndex].state = value

        conversations.changeState({
          userId: conversationUser._id,
          subjectId,
          state: value
        })
          .catch(() => {
            updatedFilteredSubjects[subjectIndex].state = prevValue
            setSubjects(updatedFilteredSubjects)
          })
      }

      if (type === 'read') {
        const prevValue = updatedFilteredSubjects[subjectIndex].read
        updatedFilteredSubjects[subjectIndex].read = value

        conversations.msgRead({
          ticketId: conversationUser._id,
          subjectId,
          isRead: value
        })
          .catch(() => {
            updatedFilteredSubjects[subjectIndex].read = prevValue
            setSubjects(updatedFilteredSubjects)
          })
      }
    })

    setSubjects(updatedFilteredSubjects)
    setChatmailCheckedSubjects({})
  }

  return (
    <ChatComposerUI
      isChatmail={isChatmail}
      channelToken={channelToken}
      chatmailHeader={chatmailHeader}
      users={users}
      handleContacts={handleContacts}
      setHeaderInput={setHeaderInput}
      chatmailInputButtons={chatmailInputButtons}
      toggleContactLockedModal={toggleContactLockedModal}
      handleCloseChatmailField={handleCloseChatmailField}
      conversationUser={conversationUser}
      getSubjects={getSubjects}
      loadingSubjects={loadingSubjects}
      setSubjectsIsOpen={setSubjectsIsOpen}
      subjectsIsOpen={subjectsIsOpen}
      composer={composer}
      dispatch={dispatch}
      setFilterValues={setFilterValues}
      setIsSubjectFiltered={setIsSubjectFiltered}
      subjectsFilterOptions={subjectsFilterOptions}
      filterValues={filterValues}
      openOutboundAction={openOutboundAction}
      subjects={subjects}
      handleSelectSubject={handleSelectSubject}
      handleStateSubject={handleStateSubject}
      handleReadSubject={handleReadSubject}
      statesOptions={statesOptions}
      chatmailCheckedSubjects={chatmailCheckedSubjects}
      chatmailAllCheckedSubjects={chatmailAllCheckedSubjects}
      setChatmailCheckedSubjects={setChatmailCheckedSubjects}
      handleAllCheckedSubjects={handleAllCheckedSubjects}
      handleChangeMultipleSubjects={handleChangeMultipleSubjects}
      disclaimerMessage={disclaimerMessage}
      onToggleNote={onToggleNote}
      isOnline={isOnline}
      useTemplate={useTemplate}
      setUseTemplate={setUseTemplate}
      channel={channel}
      disableComposer={disableComposer}
      handleDragEnter={handleDragEnter}
      handleDragLeave={handleDragLeave}
      dropZoneIsVisible={dropZoneIsVisible}
      composerAction={composerAction}
      setFilesErrorMessage={setFilesErrorMessage}
      setDropZoneIsVisible={setDropZoneIsVisible}
      showShortcutMenu={showShortcutMenu}
      shortcuts={shortcuts}
      buildShortcutMenu={buildShortcutMenu}
      onPasteAttachments={onPasteAttachments}
      messageType={messageType}
      sending={sending}
      onWriteMessage={onWriteMessage}
      message={message}
      onKeyUp={onKeyUp}
      setRefEditor={setRefEditor}
      onToggleReset={onToggleReset}
      isVirtualAssistantActive={isVirtualAssistantActive}
      setShowAIResponses={setShowAIResponses}
      showAIResponses={showAIResponses}
      currentCampaing={currentCampaing}
      withTag={withTag}
      show={show}
      provider={provider}
      updateEditor={updateEditor}
      onToggleButtons={onToggleButtons}
      disabledSend={disabledSend}
      isInstagramPost={isInstagramPost}
      onToggleModal={onToggleModal}
      setShowAudioRecorder={setShowAudioRecorder}
      setShowCamera={setShowCamera}
      setShowVideo={setShowVideo}
      onToggleEmojis={onToggleEmojis}
      showEmojis={showEmojis}
      onSelectEmoji={onSelectEmoji}
      toggleOpenSendMessage={toggleOpenSendMessage}
      onSendMessage={onSendMessage}
      resetComposer={resetComposer}
      uploading={uploading}
      filesErrorMessage={filesErrorMessage}
      files={files}
      sendPhoto={sendPhoto}
      showCamera={showCamera}
      showVideo={showVideo}
      sendVideo={sendVideo}
      uploadAudio={uploadAudio}
      showAudioRecorder={showAudioRecorder}
      showModalButtons={showModalButtons}
      showModal={showModal}
      acceptTypes={acceptTypes}
      showSendMessageModal={showSendMessageModal}
      setShowSendMessageModal={setShowSendMessageModal}
      get24HourModalTitle={get24HourModalTitle}
      setIsOpenModalSendSMS={setIsOpenModalSendSMS}
      modalMaxButtonsOpen={modalMaxButtonsOpen}
      get24HourModalBody={get24HourModalBody}
      setModalMaxButtonsOpen={setModalMaxButtonsOpen}
      replaceButtons={replaceButtons}
      isOpenModalSendSMS={isOpenModalSendSMS}
      numbersSMS={numbersSMS}
      numberSelected={numberSelected}
      setNumberSelected={setNumberSelected}
      numberToSendSMS={numberToSendSMS}
      setDialCode={setDialCode}
      setNumberToSendSMS={setNumberToSendSMS}
      numberToSendSMSMessage={numberToSendSMSMessage}
      errorModalSendSMS={errorModalSendSMS}
      sendSMSMessage={sendSMSMessage}
      sendingSMS={sendingSMS}
      gotoChannel={gotoChannel}
      setVaSuggestion={setVaSuggestion}
      handleDeleteSubject={handleDeleteSubject}
    />
  )
}

export default connect((state) => state)(ChatComposer)
